export default [
  { value: "Error", key: 0 },
  { value: "IDontLike", key: 1 },
  { value: "Capacity", key: 2 },
  { value: "Price", key: 3 },
  { value: "Addictive", key: 4 },
  { value: "Other", key: 5 },
]